/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WriteCashUserSettingsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_user_settings_messages.pb'
import {WriteCashUserSettingsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_user_settings_messages.pb'


export const writeUserSettings = (request:WriteCashUserSettingsRequest, options?: CashRequestOptions) => post<WriteCashUserSettingsRequest, WriteCashUserSettingsResponse>("/cash-app/goose-cash/v3/write-user-settings", request, {...options, rejectOnError: true })